import http from "../modules/http.index"
import { Form } from "vform"
const state = () => ({
    loading: false,
    subjectAreas: [],
    subjectAreasForm: new Form({
        id: '',
        description: "",
        default: false,
        status: false,
        amount: ""
    }),
    headers: [
        {
            text: "Id",
            align: "start",
            filterable: false,
            value: "id",
        },
        { text: "Desc", value: "description" },
        { text: "Amount", value: "amount" },
        { text: "Is Default", value: "default" },
        { text: "Status", value: "status" },
        { text: "Action", value: 'actions', sortable: false, },

    ],
})

const getters = {}
const mutations = {
    setSubjectAreas: (state, payload) => state.subjectAreas = payload
}
const actions = {
    async getSubjectAreas(ctx) {
        return new Promise((resolve, reject) => {
            ctx.state.loading = true
            http
                .get(`/Setups/SubjectArea/${ctx.rootState.site_id}`)
                .then((res) => {
                    if (res.status === 200) {
                        ctx.commit("setSubjectAreas", res.data.Data)
                        resolve(res)
                    } else reject(res)
                })
                .catch((err) => reject(err))
                .finally(() => ctx.state.loading = false)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
